// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1nEDc","header":"Messages_header__3T9CA"};